<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'partitions.cursors.title.shortLabel' | translate}}
                <app-tooltip text="{{'partitions.cursors.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="cursors-list">
        <ng-container *ngFor="let year of simulation.years">
            <section class="cursor-item" *ngIf="year.isEstimated">
                <header>
                    <h3>{{year.year}}</h3>
                </header>
                <div class="content">
                    <app-hapy-cursor
                        *ngIf="projectionRate.rate !== -1"
                        [cursor]="cursor"
                        [mode]="year.mode"
                        [value]="year.indice"
                        [isDisabled]="!year.isEditable"
                        [isNotEditable]="!year.isEditable"
                        [allowInput]="true"
                        (valueChanged)="applyValue($event, year)"></app-hapy-cursor>

                    <form #indiceForm="ngForm" class="param-form"
                        (ngSubmit)="parseAndApplyValue(year.additionalAmount, year, true)">
                        <mat-form-field>
                            <mat-label>{{'partitions.cursors.amountInput.shortLabel' | translate}}</mat-label>
                            <input matInput type="text" inputmode="numeric" name="indice" required
                                [ngModel]="year.additionalAmount | formatAmount: 'rounded': false "
                                (ngModelChange)="parseAndApplyValue($event, year, true)"
                                onclick="this.select()">
                            <span matSuffix> €</span>
                        </mat-form-field>
                    </form>
                </div>
            </section>
        </ng-container>
    </mat-card-content>
</mat-card>
